<template>
  <div class="h-full">
    <div v-if="dataAvailable" class="w-full ">
      <div class="divide-y divide-gray-300">
        <table class=" divide-y w-full divide-gray-300  mt-2 ">
          <thead class="w-full ">
          <tr class="flex flex-row px-4 ">
            <th class="w-28 sm:w-44 ml-2 sm:ml-0 text-left text-l font-semibold text-gray-900"> {{ $t('widget.sync.object') }}</th>
            <th class="text-left text-l font-semibold text-gray-900 ">{{ $t('widget.sync.problem') }}</th>
          </tr>
          </thead>
          <tbody  :class=" 'divide-y divide-gray-200  flex flex-col overflow-y-auto ' + height" >
            <synchronisation-object v-for="item in data.datasets"
                                    :key="item.id"
                                    :name="item.name"
                                    :backgroundColor="item.backgroundColor"
                                    :textColor="item.textColor"
                                    :date="item.date"
                                    :problem="item.objectType"
                                    :url="item.url"></synchronisation-object>
          </tbody>
        </table>
<!--        <div class="text-center px-3 mb-1 text-sm flex flex-col ">-->
<!--          <a :href="[data.moreInfoUrl]" class="moreInfoUrl"> {{ $t('widget.moreInfo') }} </a> -->

<!--        </div>-->
      </div>
    </div>

    <div v-if="!dataAvailable" class="h-full flex justify-center -mt-8">
      <p class="self-center px-4 text-center">{{ $t('widget.sync.nothing') }}</p>
    </div>
  </div>
</template>

<script setup>
import SynchronisationObject from "@/widgetContent/listItems/SynchronisationObject";
import {defineEmits, defineProps, onMounted, ref} from "vue";

import ApiService from "@/services/ApiService";
let apiService = new ApiService;
const emit = defineEmits(["dataLoaded"])

let props = defineProps({
  update: Number,
  source: String,
  style: Object,
  colorPalette: Object,
  pills: Array,
  type: String,
  hasLongTitle: Boolean
})
let data = ref(Object);
let dataAvailable = ref();
let height= ref(" h-48 ");

onMounted ( async () => {
  if (props.hasLongTitle){
    height.value = " h-40 "
  }
  data.value = await apiService.get(props.source);
  emit("dataLoaded")
  dataAvailable.value = data.value.datasets.length > 0;
  }
)

</script>
